import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconBluetoothSvg } from "./IconBluetoothSvg.mjs";
const IconBluetooth = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconBluetoothSvg, ...svgProps }) });
export {
  IconBluetooth
};
